import { SecurityContext } from 'auth/contexts/SecurityContext';
import { useContext } from 'react';

export function useSecurity() {
  return useContext(SecurityContext);
}
